<template>
    <div id="middlePage"></div>
</template>

<script>
    export default {
        name: "middlePage",
        data(){
            return{
            }
        },
        methods:{
           //获取url参数 
           getQueryVariable(variable){
                var query = window.location.search.substring(1);
                var vars = query.split("&");
                for (var i=0;i<vars.length;i++) {
                        var pair = vars[i].split("=");
                        if(pair[0] == variable){return pair[1];}
                }
                return(false);
            }
        },
        created(){
            console.log(window.location.protocol);
            window.location.href = window.location.protocol+'//'+this.getQueryVariable('domain')+'/'+this.getQueryVariable('path')+'?domain='+this.getQueryVariable('domain')+'&code='+this.getQueryVariable('code')+'&state='+this.getQueryVariable('state');
            console.log(12312312);
        },
        mounted(){
        
        },
    }
</script>

<style scoped lang="scss"></style>